const ENDPOINTS = {
    accountSummary: '/v2/credit/accounts/summary',
    authorizedBuyersLookup: '/v1/credit/accounts/eligible/authbuyer/lookup',
    authorizedUsers: '/v1/credit/accounts/authorized-users',
    creditAccounts: '/v2/credit/accounts',
    creditLimitChange: '/v1/credit/accounts/management/credit-limit-increase',
    changePaymentDueDate: 'v1/credit/billing/due-date',
    logout: '/v3/oauth2/logout'
};
export default ENDPOINTS;
